// extracted by mini-css-extract-plugin
export default {"Wrapper":"CarouselSelector_Wrapper__RYmrX","CircleSelector":"CarouselSelector_CircleSelector__zsJiR","Arrow":"CarouselSelector_Arrow__cCoHp"};